import React, { useEffect, useMemo, useRef } from "react";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";
import PlanOptions from "../../components/modal/PlanOption/PlanOptions";
import KC_Heading0 from "../../designsystem/typography/KC-Heading/KC_Heading0";
import { tt } from "../../utils/i18n/i18n";
import CONFIG from "../../model/TSConfig";
import SubscriptionPlanDTO, {
  SubscriptionPlanType
} from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";
import KC_Padder from "../../designsystem/KC_Padder/KC_Padder";
import { useUrlQuery } from "../../utils/hooks/useUrlQuery";

export default function PublicPrices() {
  const searchParamz = useUrlQuery();
  const listenerAdded = useRef(false);

  const hasKCTheme = useMemo(() => {
    return !!searchParamz.get("kc");
  }, [searchParamz]);

  const handlePlanClick = (plan: SubscriptionPlanDTO, commitment: string) => {
    const target = hasKCTheme ? "_blank" : "_self";
    const baseUrl = `${CONFIG.publicURL}${CONFIG.baseName ? `/${CONFIG.baseName}` : ""}`;

    if (plan.type === SubscriptionPlanType.ENTERPRISE) {
      window.open(
        "https://calendly.com/d/cnwv-bwk-8mr/demande-de-devis-kadow-club",
        target
      );
    } else {
      window.open(
        `${baseUrl}/signup?planId=${plan._id}&duration=${commitment}`,
        target
      );
    }
  };

  /**
   * Prices page is embedded as an iframe in the public website (https://kadow.club).
   * This code propagates scroll events to the iframe's host.
   */
  useEffect(() => {
    if (!hasKCTheme) {
      return;
    }

    if (listenerAdded.current) {
      return;
    }

    listenerAdded.current = true;

    window.addEventListener(
      "wheel",
      (e) => {
        const el = document.scrollingElement;
        if (!el) {
          return;
        }
        const atTop = el.scrollTop === 0 && e.deltaY < 0;
        const atBottom =
          el.scrollTop + el.clientHeight >= el.scrollHeight && e.deltaY > 0;

        if (atTop || atBottom) {
          // Hit the edge — let the parent scroll
          window.parent?.postMessage(
            { type: "iframeWheel", deltaY: e.deltaY },
            "https://kadow.club"
          );
        }
        // Otherwise the iframe scrolls normally — no need to do anything
      },
      { passive: true }
    );
  }, [hasKCTheme, listenerAdded.current]);

  return (
    <div
      id="public-price"
      className="d-flex flex-column align-items-center w-100"
    >
      <div className="container">
        {!hasKCTheme && (
          <div className="row mt-4">
            <div className="col-12 text-center">
              <KC_Heading0 text={tt("public_prices_heading")} />
            </div>
          </div>
        )}
      </div>
      <PlanOptions
        onPlanClick={handlePlanClick}
        freePlanIsPink={true}
        hasKCTheme={hasKCTheme}
        showCurrentPlan={false}
      />
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <KC_UIText weight="reg" text={tt("public_prices_guarantee_text")} />
          </div>
        </div>
        <KC_Padder />
      </div>
    </div>
  );
}
